module.exports = __webpack_public_path__ + "static/media/interac.306e6a21.svg";